var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 62,
    viewBox: "0 0 105 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 40.5L71 46.5",
    stroke: "#8AFCDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0081 29.7298L56.2227 32.4297",
    stroke: "#8AFCDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 2L77.75 26.75",
    stroke: "#8AFCDA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 2L86.75 47L77.75 26.75L57.5 17.75L102.5 2Z",
    stroke: "#8AFCDA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7519 35.0826C61.6766 42.1336 52.9349 51.6141 42.7 47.8577C38.7449 46.4061 34.4508 43.1112 33.0503 39.0218C32.1239 36.3167 32.2516 32.7105 35.9249 31.8116C40.0745 30.7962 41.6026 34.2582 42.7894 36.5736C44.6481 40.1998 44.6756 44.8479 44.2068 48.7758C43.3361 56.0725 36.4946 56.707 30.2384 56.9668C21.2971 57.3383 13.3629 56.3107 1.24724 52.3471",
    stroke: "#8AFCDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.77b8ccd0f7fba8baa12755499d117008.svg";
export { ForwardRef as ReactComponent };